import React from 'react';
import { Maximize2, Pencil, X } from 'lucide-react';
import { TaskyButton, TaskyIconButton } from '../../../components/tasky';
import type { TouchUpIntent } from '../../../utils/touchUpIntent';

interface TouchUpHintProps {
  intent: TouchUpIntent;
  onOpen: () => void;
  onDismiss: () => void;
}

const COPY: Record<TouchUpIntent, { message: string; action: string; track: string; Icon: typeof Pencil }> = {
  edit: {
    message:
      '「画像を編集」なら、ほかの部分を変えずに文字や一部分を直せます。',
    action: '画像を編集で直す',
    track: 'banner-touchup-hint-edit',
    Icon: Pencil,
  },
  resize: {
    message: '「マジックリサイズ」なら、デザインを変えずに複数のサイズを一度に作れます。',
    action: 'マジックリサイズで作る',
    track: 'banner-touchup-hint-resize',
    Icon: Maximize2,
  },
};

/**
 * 生成済みバナーを参照画像にして手直しっぽい指示を書いたときに、
 * 全体を作り直す前に編集機能・マジックリサイズを案内する。
 */
const TouchUpHint: React.FC<TouchUpHintProps> = ({ intent, onOpen, onDismiss }) => {
  const { message, action, track, Icon } = COPY[intent];
  return (
    <div
      role="note"
      data-testid="touchup-hint"
      className="mt-2 flex items-start gap-2 rounded-lg border border-warm-border bg-warm-surface p-3 text-sm text-gray-700"
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" aria-hidden="true" />
      <div className="flex-1">
        <p>{message}</p>
        <TaskyButton type="button" size="sm" className="mt-2" onClick={onOpen} data-track={track}>
          {action}
        </TaskyButton>
      </div>
      <TaskyIconButton
        type="button"
        variant="ghost"
        size="sm"
        aria-label="この案内を閉じる"
        onClick={onDismiss}
        data-track="banner-touchup-hint-dismiss"
      >
        <X aria-hidden="true" />
      </TaskyIconButton>
    </div>
  );
};

export default TouchUpHint;
